<template>
  <section class="space-y-2 py-4">
    <slot />
  </section>
</template>
